import renderingsSoftApartment from '@/assets/img/users-cases/renderings-soft-apartment.webp';
import renderingsSoftApartmentHow from '@/assets/img/users-cases/renderings-soft-apartment-how.webp';
import renderingsSoftApartmentResult from '@/assets/img/users-cases/renderings-soft-apartment-result.webp';

export default {
  slug: 'renderings-soft-apartment',
  order: 29,
  title: '3D Renderings Soft Apartment',
  subtitle: 'Creating realistic 3D apartment renderings with soft interior design using AI rendering software.',
  tags: ['3DRendering', 'InteriorVisualization'],

  images: {
    hero: renderingsSoftApartment,
    aboutTop: renderingsSoftApartmentHow,
    aboutBottom: renderingsSoftApartmentResult,
  },

  howText:
    'The apartment floorplan was uploaded into the floor plan render AI, which generated detailed 2D layouts, then produced fully furnished 3D renderings with soft interior styling. Finally, a 360° virtual tour was created to allow potential buyers to explore each space online before presales.',

  resultText:
    'Using floor plan render AI, the developer obtained detailed 2D floor plans, lifelike 3D renderings of each apartment, and fully interactive 360° tours. These visualizations helped potential buyers virtually experience the apartments, increasing engagement, accelerating presale conversions, and reducing the need for traditional archviz production.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
